export default [{
  path: '/atualizacao-indices',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Atualização de Índices',
      path: 'index',
      component: () => import('@/views/atualizacaoIndices/index.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        breadcrumb: [
          { name: 'Dados', path: '/dados'},
          { name: 'Índice IPCA' }
        ]
      }
    },
    {
      name: 'Atualização de Índices Editar',
      path: 'edit/:data_registro',
      component: () => import('@/views/atualizacaoIndices/Edit.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        breadcrumb: [
          { name: 'Dados', path: '/dados' },
          { name: 'Índice IPCA', path: '/atualizacao-indices/index' },
          { name: 'Editar' },
        ]
      }
    },
    {
      name: 'Atualização de Índices Adicionar',
      path: 'edit',
      component: () => import('@/views/atualizacaoIndices/Edit.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        breadcrumb: [
          { name: 'Dados', path: '/dados' },
          { name: 'Índice IPCA', path: '/atualizacao-indices/index' },
          { name: 'Adicionar' },
        ]
      }
    },
    {
      name: 'Indices IPCA Editar',
      path: 'edit-ipca-estimado/:data_registro',
      component: () => import('@/views/atualizacaoIndices/EditIpcaEstimado.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        breadcrumb: [
          { name: 'Dados', path: '/dados' },
          { name: 'Índice IPCA', path: '/atualizacao-indices/index' },
          { name: 'Editar IPCA Estimado' },
        ]
      },
    },
    {
      name: 'Indices IPCA Adicionar',
      path: 'edit-ipca-estimado',
      component: () => import('@/views/atualizacaoIndices/EditIpcaEstimado.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        breadcrumb: [
          { name: 'Dados', path: '/dados' },
          { name: 'Índice IPCA', path: '/atualizacao-indices/index' },
          { name: 'Adicionar IPCA Estimado' },
        ]
      }
    }
  ]
}]